import { sendOtp, loginDoctor } from "../../../Common/axios_instance/auth_https/auth.https";
import { LoginTab } from "../interfaces/login_module.interface";

export const sendLoginOtp = (activeTab: LoginTab, phone: string, email: string) => {
  const payload = activeTab === "phone"
    ? { mobileNumber: phone, countryCode: "91" }
    : { email };
  return sendOtp(payload);
};

export const verifyLoginOtp = (activeTab: LoginTab, phone: string, email: string, otp: string) => {
  const payload = activeTab === "phone"
    ? { mobileNumber: phone, countryCode: "91", otp }
    : { email, otp };
  return loginDoctor(payload);
};
